import { Component, DOCUMENT, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ToolbarComponent } from 'src/app/components/toolbar/toolbar.component';
import { FsLogoComponent } from '../../icons/fs-logo/fs-logo.component';

@Component({
  selector: 'app-impressum',
  templateUrl: './impressum.component.html',
  styleUrls: ['./impressum.component.scss'],
  imports: [ToolbarComponent, RouterLink, FsLogoComponent],
})
export class ImpressumComponent {
  public document = inject(DOCUMENT);
}
